export function formatPhone(phone: string): string {
    const cleaned = phone.replace(/\D/g, "");

    if (cleaned.length === 11 && cleaned.startsWith("1")) {
        return cleaned.replace(/(\d)(\d{3})(\d{3})(\d{4})/, "$1 ($2) $3-$4");
    }

    if (cleaned.length === 10) {
        return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    }

    return phone;
}

/**
 * Cleans a phone number by removing all non-digit characters
 * @param phone - Phone number in any format
 * @returns Phone number with only digits
 */
export function cleanPhone(phone: string): string {
    return phone.replace(/\D/g, "");
}

/**
 * Validates a phone number against backend requirements (NANP)
 * First digit must be 2-9, fourth digit must be 2-9
 * @param phone - 10-digit phone number
 * @returns true if valid, false otherwise
 */
export function isValidNanpaPhone(phone: string): boolean {
    const cleaned = cleanPhone(phone);
    return /^[2-9]{1}[0-9]{2}[2-9]{1}[0-9]{6}$/.test(cleaned);
}
